// Standard Library Imports
import React, { useEffect, useState } from 'react';
// Internal Module Imports
import TabsComponent from '../../../components/Tabs/Tabs';
import { useQueryParamWithDefault } from '../../../hooks';
import Credits from './Credits';
// CSS Imports
import classes from './Economics.module.css';
import RevenueCalulator from './RevenuePotentialCalculator/RevenueCalulator';
import Invoice from './Invoice';
import InvoiceHistory from './Invoice/InvoiceHistory';
import Overview from '../../Reusables/Economics/Overview';
import Ledger from '../../Reusables/Economics/Ledger';
import { NumberParam } from 'use-query-params';
import SmartCharge from '../../Reusables/Economics/SmartCharge/SmartCharge';
import { EsettSettlements } from '../../Reusables/Economics/Esett/EsettSettlements';

const Economics = ({ cId }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('tab', NumberParam, 0, cId);

    const [historyTab, setHistoryTab] = useState(false);

    useEffect(() => {
        if (historyTab) {
            setSelectedIndex(7);
        }
    }, [historyTab]);

    useEffect(() => {
        if (historyTab && selectedIndex !== 7) {
            setHistoryTab(false);
        }
    }, [selectedIndex]);

    const tabs = [
        {
            name: 'Ledger',
            component: <Ledger cId={cId} setSelectedIndex={setSelectedIndex} />,
            tabId: 1,
        },
        {
            name: 'Overview',
            component: <Overview cId={cId} />,
            tabId: 2,
        },
        {
            name: 'Transactions',
            component: <Credits cId={cId} />,
            tabId: 3,
        },
        {
            name: 'Invoice',
            component: <Invoice setHistoryTab={setHistoryTab} cId={cId} />,
            tabId: 4,
        },
        {
            name: 'Smart Charge Ledger',
            component: <SmartCharge cId={cId} />,
            tabId: 5,
        },
        {
            name: 'Revenue Potential Calculator',
            component: <RevenueCalulator cId={cId} />,
            tabId: 6,
        },
        {
            name: 'eSett Settlements',
            component: <EsettSettlements />,
            tabId: 7,
        },
        ...(historyTab
            ? [
                  {
                      name: 'Invoice History',
                      component: <InvoiceHistory />,
                      tabId: 8,
                  },
              ]
            : []),
    ];

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <TabsComponent
                tabs={tabs}
                selectedIndex={selectedIndex}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

export default Economics;
